import React from "react";
import { BooleanInput, Datagrid, List, NumberInput, SelectInput, TextField, TextInput } from "react-admin";
import { GenericColorChip } from "shared/components/chips/GenericColorChip";
import CustomDateField from "shared/components/fields/CustomDateField";
import {
  FinlandCommunicationAssetLevelColorMapping,
  FinlandCommunicationDirectionColorMapping,
  FinlandCommunicationProtocolTypeColorMapping,
  FinlandCommunicationServiceOperatorColorMapping,
} from "shared/enums/colorMappings/finlandCommunicationColorMappings";
import { FinlandCommunicationProtocolTypeEnum } from "shared/enums/globalEnums";
import {
  finlandCommunicationAssetLevelChoices,
  finlandCommunicationDirectionChoices,
  finlandCommunicationServiceOperatorChoices,
} from "shared/enums/reactAdminChoices";

const ConfigProtocolParametersList = () => {
  const filters = React.useMemo(
    () => [
      <SelectInput
        source="service_operator"
        choices={finlandCommunicationServiceOperatorChoices}
        key="service_operator"
      />,
      <SelectInput source="asset_level" choices={finlandCommunicationAssetLevelChoices} key="asset_level" />,
      <NumberInput source="asset_id" key="asset_id" />,
      <TextInput source="metric" key="metric" />,
      <SelectInput source="direction" choices={finlandCommunicationDirectionChoices} key="direction" />,
      <BooleanInput source="deleted" key="deleted" />,
      <NumberInput source="protocol_config_id" key="protocol_config_id" />,
      <NumberInput source="address" key="address" />,
    ],
    [],
  );
  return (
    <List
      filters={filters}
      filter={{
        protocol_type: FinlandCommunicationProtocolTypeEnum.MODBUS,
      }}
    >
      <Datagrid bulkActionButtons={false}>
        <TextField source="id" />
        <GenericColorChip source="protocol_type" colorMapping={FinlandCommunicationProtocolTypeColorMapping} />
        <GenericColorChip source="service_operator" colorMapping={FinlandCommunicationServiceOperatorColorMapping} />
        <GenericColorChip source="asset_level" colorMapping={FinlandCommunicationAssetLevelColorMapping} />
        <TextField source="asset_id" label="Asset ID" />
        <TextField source="metric" />
        <GenericColorChip source="direction" colorMapping={FinlandCommunicationDirectionColorMapping} />
        <TextField source="range_min" />
        <TextField source="range_max" />
        <TextField source="protocol_config_id" />
        <TextField source="address" />
        <CustomDateField source="created_at" showTime />
        <CustomDateField source="updated_at" showTime />
      </Datagrid>
    </List>
  );
};

export default ConfigProtocolParametersList;
